import React, { useState, useEffect, useRef } from "react";
import { Card, CardBody } from "reactstrap";
import BreadcrumbItem from "../../Components/common/Breadcrumb";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import { ToastContainer, toast } from "react-toastify";
import { ShipmentsService } from "../../services/shipment-service/shipments";
import { AddressBookService } from "../../services/shipment-service/addressbook";
import { ShipmentSettingsService } from "../../services/registry/shipmentSettings";
import RateItem from "./rateItem";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "../../Components/common/Loader";
import { useOidcUser } from "@axa-fr/react-oidc";
import { callErrorToast } from "../../utilities";
import { useAppContext } from "../../AppProvider";

const shipmentService = new ShipmentsService();
const addressBookService = new AddressBookService();
const shipmentSettingsService = new ShipmentSettingsService();

const ShipmentRate = () => {
  const { id } = useParams();
  const { oidcUser } = useOidcUser();
  const [shipment, setShipment] = useState({});
  const [shipmentSetting, setShipmentSetting] = useState({});
  const [pickup, setPickup] = useState(null);
  const [delivery, setDelivery] = useState(null);
  const [rateList, setRateList] = useState([]);
  const [attachmentTypes, setAttachmentTypes] = useState([]);
  const [loadingItem, setLoadingItem] = useState(false);
  const [loadingAll, setLoadingAll] = useState(false);
  const [updateRate, setUpdateRate] = useState(false);
  const navigate = useNavigate();

  const { dictionary } = useAppContext();

  const getRate = () => {
    shipmentService
      .getRate(id)
      .then((response) => {
        let rateList = [];
        if (response.rateList) {
          rateList = [...response.rateList];
          const ratesModule = response.rateList.length % 3;
          const missingRates =
            response.rateList.length < 3 ? 3 - ratesModule : 0;
          for (let i = 0; i < missingRates; i++) {
            rateList = [...rateList, {}];
          }
        }

        setRateList(rateList);
        setShipment(response.shipmentInfoDetail);
        setLoadingAll(false);
        setUpdateRate(false);

        getPickup(response.shipmentInfoDetail.pickupId);
        getDelivery(response.shipmentInfoDetail.deliveryId);
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };

  const getPickup = (id) => {
    addressBookService
      .getAddress(id)
      .then((response) => {
        setPickup(response);
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };

  const getDelivery = (id) => {
    addressBookService
      .getAddress(id)
      .then((response) => {
        setDelivery(response);
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };

  const getShipmentSetting = () => {
    shipmentSettingsService
      .all({
        search: [
          {
            selector: "ownerId",
            value: oidcUser.owner,
            preciseSearch: true,
          },
        ],
      })
      .then((response) => {
        if (response.data?.content) {
          setShipmentSetting(response.data.content[0]);
        }
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };

  useEffect(() => {
    if (oidcUser) {
      getShipmentSetting();
    }
  }, [oidcUser]);

  useEffect(() => {
    getRate();
  }, []);

  return (
    <React.Fragment>
      <div className="my-3 mx-3" id="container">
        {loadingAll ? (
          <Loader show={loadingAll} />
        ) : rateList.length > 0 ? (
          <Slide
            infinite={false}
            autoplay={false}
            transitionDuration={300}
            arrows={rateList.length > 3}
            canSwipe={rateList.length > 3}
            indicators={rateList.length > 3}
            responsive={[
              {
                breakpoint: 800,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                },
              },
              {
                breakpoint: 500,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
            ]}
          >
            {rateList.length > 0 &&
              rateList.map((elem, index) => {
                return (
                  <RateItem
                    key={index}
                    data={elem}
                    shipmentId={id}
                    shipmentData={shipment}
                    attachmentTypesList={attachmentTypes}
                    setLoadingAll={setLoadingAll}
                    loadingAll={loadingAll}
                    setLoadingItem={setLoadingItem}
                    loadingItem={loadingItem}
                    getRate={getRate}
                    updateRate={updateRate}
                    setUpdateRate={setUpdateRate}
                    pickup={pickup}
                    delivery={delivery}
                    shipmentSetting={shipmentSetting}
                  />
                );
              })}
          </Slide>
        ) : (
          <Card className="mt-3">
            <CardBody>
              <h5 className="text-center mb-0">
                {dictionary.rating.no_rates_found}
              </h5>
            </CardBody>
          </Card>
        )}
        <div className="row">
          <div className="col justify-space-between">
            <button
              hidden={loadingAll}
              type="button"
              className="btn btn-light btn-sm"
              onClick={() => {
                navigate(`/shipments/edit/${id}`);
              }}
            >
              <i className="ph-arrow-left ph-sm me-2"></i>
              {dictionary.words.back}
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ShipmentRate;
